import React from 'react'
import { useViewport } from '../../../utils'
import { ButtonBookmarkIcon } from '../../../components'
import { CardImage } from './card-image'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'
import { useInternationalization } from '../../../features/i18n'

const MAX_TITLE_LENGTH = 50
// const MAX_EXCERPT_LENGTH = 180

const Card = ({data, embed, bookmark}) => {
  const { translate, language } = useInternationalization()
  const {
    image,
    date,
    organization,
    title,
    excerpt,
    special
  } = data

  const { isMobile } = useViewport()
  const metaFontSize = embed ? '10px' : isMobile ? '12px' : '14px'
  const withExcerpt = excerpt && !bookmark
  const titleRendered = typeof title === 'string' ? title : title && title[language.name] ? title[language.name] : String(title)
  const titleTrimmed = excerptTrimmer(titleRendered, MAX_TITLE_LENGTH)

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 flex flex-col md:flex-row relative h-full"
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
      title={titleRendered}
    >
      <CardImage bookmark={bookmark} isMobile={isMobile} image={image}/>
      <div>
        <div className={`${bookmark ? 'w-10/12 lg:w-8/12' : ''}`}>
          <p className={`lg:text-sm font-bold`} style={{fontSize: metaFontSize}}>{date}</p>
          <p className={`text-gray-999 mb-2`} style={{fontSize: metaFontSize}}>{organization} /</p>
        </div>
        {
          special &&
          <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>
            {translate('EVENT', 'special')}
          </div>
        }
        <h3 className={`${withExcerpt ? 'mb-2' : ''} font-bold font-primary ${embed ? 'text-xs' : 'text-sm'} lg:text-lg`}>
          {titleTrimmed}
        </h3>
        {/* {
          withExcerpt &&
          <p className="text-sm text-gray-444">{excerpt}</p>
        } */}
      </div>
      {
        bookmark && !isMobile &&
        <ButtonBookmarkIcon className="bg-white m-5 absolute top-0 right-0"/>
      }
    </div>
  )
}

export { Card }
